<!-- Custom loader elements -->
<section class="vpb-loader card" id="vPlaybookLogo" style="display:none">
	<div class="custom-loader-circle">
		<img class="loader-image" src="../../../../assets/img/logo-vplaybook-sm.png" />
	</div>
	<div class="custom-loader-line-mask">
		<div class="custom-loader-line"></div>
	</div>
	<div class="clear"></div>
</section>
<section class="vpb-loader card" id="simpleLoader" style="display:none">
	<div class="custom-loader-circle">
		<img class="loader-image" src="../../../../assets/img/logo-vplaybook-sm.png" />
	</div>
	<div class="custom-loader-line-mask">
		<div class="custom-loader-line"></div>
	</div>
	<div class="clear"></div>
</section>
<section id="playbookloader" style="display:none">
  <div class="status-bar slide" style="font-size: 15px;">
	Saving...
	<img class="loading-icon" src="../../../../assets/img/loader2.gif" alt="" />
  </div>
</section>
